import { createServices } from '@vs/vsf-boot';
export default createServices({});
